import clsx from "clsx";

interface Props {
  direction: "asc" | "desc";
  onToggle: (desc: boolean) => void;
}

export const SortingIndicator = ({ direction, onToggle }: Props) => {
  return (
    <button
      className={clsx(
        "flex justify-center items-center bg-cosmic-3 rounded w-6 h-6 text-cosmic",
      )}
      onClick={() => onToggle(direction !== "desc")}
    >
      <i
        className={clsx("fa-regular fa-sharp", {
          "fa-arrow-down": direction === "desc",
          "fa-arrow-up": direction === "asc",
        })}
      />
    </button>
  );
};
